import { render, staticRenderFns } from "./G_020_JuchuEntry_ChildActionsBtn.vue?vue&type=template&id=2dbd7909&"
import script from "./G_020_JuchuEntry_ChildActionsBtn.vue?vue&type=script&lang=ts&"
export * from "./G_020_JuchuEntry_ChildActionsBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports